import useHasPlaidMarketingConsent, {
  PlaidMarketingConsentEntryPoint,
} from 'features/plaid/hooks/useHasPlaidMarketingConsent';
import usePlaidLinkLauncher from 'features/plaid/hooks/usePlaidLinkLauncher';
import { useEffect } from 'react';
import { HomeTileTypeIds } from 'shared/hooks/homeTiles/HomeTileTypeIds';
import useRefreshHomeTiles from 'shared/hooks/homeTiles/useRefreshHomeTiles';

export const usePlaidWrapperForHome = () => {
  const { refreshTiles } = useRefreshHomeTiles([
    HomeTileTypeIds.VXL_CARD_GROUP_TILE_FOR_YOU,
  ]);
  const { startPlaidOrShowConsent } = useHasPlaidMarketingConsent({
    entryPoint: PlaidMarketingConsentEntryPoint.Home,
  });

  const {
    startLaunch,
    cancelLaunch,
    error: plaidError,
  } = usePlaidLinkLauncher(PlaidMarketingConsentEntryPoint.Home, {
    onResult: (result) => {
      if (result.status === 'success') {
        refreshTiles();
      }
    },
  });

  const startPlaid = () => {
    startPlaidOrShowConsent(startLaunch);
  };

  useEffect(() => {
    if (!plaidError) {
      return;
    }

    cancelLaunch();
  }, [cancelLaunch, plaidError]);

  return {
    startPlaid,
  };
};
